import { ArrowRight, MessageCircle, Target, Video } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import MarketingPageShell from '../components/marketing/MarketingPageShell';
import { trackCTA } from '../utils/metaPixel';

interface FeatureInterviewPrepPageProps {
  onNavigate?: (view: string) => void;
}

const FEATURE_POINTS = [
  { icon: Target, key: 'roleSpecific' },
  { icon: MessageCircle, key: 'mockQuestions' },
  { icon: Video, key: 'videoPrep' },
] as const;

const FeatureInterviewPrepPage: React.FC<FeatureInterviewPrepPageProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  const handleSignup = () => {
    trackCTA('feature_interview_prep_signup');
    onNavigate?.('signup');
  };

  return (
    <MarketingPageShell
      onNavigate={onNavigate}
      activeView="feature-interview-prep"
      title={t('pages.interviewPrep.seoTitle', 'AI Interview Prep | GoGrabJob')}
      description={t(
        'pages.interviewPrep.seoDescription',
        'Practice role-specific interview questions tied to the jobs you apply for — with AI feedback on clarity and structure.',
      )}
      canonical="https://www.gograbjob.com/features/interview-prep"
    >
      <div className="marketing-page-hero-band">
        <h1 className="marketing-page-hero-band__title">
          {t('pages.interviewPrep.title', 'Interview prep tied to your applications')}
        </h1>
        <p className="marketing-page-hero-band__lede">
          {t(
            'pages.interviewPrep.lede',
            'Every application keeps its context — mock questions, answer feedback, and prep videos for the exact role you targeted.',
          )}
        </p>
      </div>

      <div className="marketing-feature-grid">
        {FEATURE_POINTS.map(({ icon: Icon, key }) => (
          <article key={key} className="marketing-feature-grid__card">
            <div className="marketing-feature-grid__icon" aria-hidden>
              <Icon className="h-5 w-5" />
            </div>
            <h2 className="marketing-feature-grid__title">
              {t(`pages.interviewPrep.points.${key}.title`)}
            </h2>
            <p className="marketing-feature-grid__body">
              {t(`pages.interviewPrep.points.${key}.body`)}
            </p>
          </article>
        ))}
      </div>

      <div className="marketing-page-cta-band">
        <button type="button" className="home-marketing-cta group" onClick={handleSignup}>
          {t('pages.interviewPrep.cta', 'Start practicing free')}
          <ArrowRight className="h-4 w-4 shrink-0" aria-hidden />
        </button>
      </div>
    </MarketingPageShell>
  );
};

export default FeatureInterviewPrepPage;
